/* F-20 Grill Landing — behavior. Loaded as a theme asset (CSP-safe). */
(function () {
  function init() {
    var root = document.getElementById('hf-f20') || document;
    var $ = function (id) { return document.getElementById(id); };

    // Nav + sticky bar
    var nv = $('nv'), sb = $('sb');
    if (nv || sb) {
      window.addEventListener('scroll', function () {
        if (nv) nv.classList.toggle('solid', window.scrollY > 80);
        if (sb) sb.classList.toggle('show', window.scrollY > window.innerHeight * 0.72);
      }, { passive: true });
    }

    // Scroll reveal
    var rv = root.querySelectorAll('.rv');
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('on'); obs.unobserve(e.target); }
        });
      }, { threshold: 0.07, rootMargin: '0px 0px -36px 0px' });
      rv.forEach(function (el) { obs.observe(el); });
    } else {
      rv.forEach(function (el) { el.classList.add('on'); });
    }

    // Tabs
    root.querySelectorAll('.tb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var t = btn.getAttribute('data-tab');
        root.querySelectorAll('.tb').forEach(function (b) { b.classList.remove('on'); });
        root.querySelectorAll('.tp').forEach(function (p) { p.classList.remove('on'); });
        btn.classList.add('on');
        var panel = $('tab-' + t);
        if (panel) panel.classList.add('on');
      });
    });

    // FAQ (no-op if none present)
    root.querySelectorAll('.faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('.faq-item');
        var wasOpen = item.classList.contains('open');
        root.querySelectorAll('.faq-item.open').forEach(function (i) { i.classList.remove('open'); });
        if (!wasOpen) item.classList.add('open');
      });
    });

    // Vehicle selector
    var MAKES_MODELS = {
      'Toyota':      ['Tacoma','Tundra','4Runner','Sequoia','Land Cruiser','Sienna','RAV4','Highlander','FJ Cruiser','Venza'],
      'Ford':        ['F-150','F-250 Super Duty','F-350 Super Duty','Ranger','Maverick','Bronco','Bronco Sport','Explorer','Expedition','Edge','Escape','Transit','Transit Connect','Excursion'],
      'Chevrolet':   ['Silverado 1500','Silverado 2500 HD','Silverado 3500 HD','Colorado','Tahoe','Suburban','Traverse','Blazer','Equinox','Express'],
      'GMC':         ['Sierra 1500','Sierra 2500 HD','Sierra 3500 HD','Canyon','Yukon','Yukon XL','Acadia','Terrain','Savana','Hummer EV'],
      'Ram':         ['1500','2500','3500','ProMaster','ProMaster City'],
      'Jeep':        ['Wrangler','Gladiator','Grand Cherokee','Grand Cherokee L','Cherokee','Wagoneer','Grand Wagoneer','Commander','Liberty'],
      'Nissan':      ['Frontier','Titan','Titan XD','Pathfinder','Armada','Xterra','Murano','NV Cargo','NV200'],
      'Honda':       ['Ridgeline','Pilot','Passport','Odyssey','CR-V','Element'],
      'Subaru':      ['Outback','Forester','Ascent','Crosstrek','Solterra','Baja'],
      'Dodge':       ['Durango','Grand Caravan','Journey','Ram 1500 Classic'],
      'Acura':       ['MDX','RDX','ZDX'],
      'Audi':        ['Q5','SQ5','Q7','Q8'],
      'BMW':         ['X3','X5','X6','X7'],
      'Buick':       ['Enclave','Envision','Encore'],
      'Cadillac':    ['Escalade','Escalade ESV','XT5','XT6'],
      'Chrysler':    ['Pacifica','Voyager','Aspen'],
      'Hyundai':     ['Santa Fe','Palisade','Tucson','Santa Cruz'],
      'Infiniti':    ['QX60','QX80','QX50','QX56'],
      'Kia':         ['Telluride','Sorento','Sportage','Carnival'],
      'Land Rover':  ['Defender','Discovery','Range Rover','Range Rover Sport','LR4'],
      'Lexus':       ['GX','LX','RX','TX'],
      'Lincoln':     ['Navigator','Aviator','Nautilus','Corsair'],
      'Mazda':       ['CX-9','CX-90','CX-5','CX-50','CX-70'],
      'Mercedes':    ['Sprinter','Metris','G-Class','GLE','GLS','GLC'],
      'Mitsubishi':  ['Outlander','Montero','Pajero Sport'],
      'Rivian':      ['R1T','R1S'],
      'Tesla':       ['Model X','Model Y','Cybertruck'],
      'Volkswagen':  ['Atlas','Atlas Cross Sport','Tiguan','Taos','ID.4'],
      'Volvo':       ['XC90','XC60','XC40']
    };
    var yearSel = $('veh-year'), makeSel = $('veh-make'), modelSel = $('veh-model'), submitBtn = $('veh-submit');

    if (yearSel && makeSel && modelSel && !window.__hfVehInit) {
      for (var y = 2026; y >= 2003; y--) { var o = document.createElement('option'); o.value = o.text = y; yearSel.appendChild(o); }
      Object.keys(MAKES_MODELS).forEach(function (m) { var op = document.createElement('option'); op.value = op.text = m; makeSel.appendChild(op); });

      function checkSubmit() { if (submitBtn) submitBtn.disabled = !(yearSel.value && makeSel.value && modelSel.value); }
      function onYear() { makeSel.disabled = !yearSel.value; checkSubmit(); }
      function onMake() {
        modelSel.innerHTML = '<option value="">Model</option>';
        var v = makeSel.value;
        if (v && MAKES_MODELS[v]) {
          MAKES_MODELS[v].forEach(function (m) { var op = document.createElement('option'); op.value = op.text = m; modelSel.appendChild(op); });
          modelSel.disabled = false;
        } else { modelSel.disabled = true; }
        checkSubmit();
      }
      yearSel.addEventListener('change', onYear);
      makeSel.addEventListener('change', onMake);
      modelSel.addEventListener('change', checkSubmit);

      function confirmVehicle() {
        if (!(yearSel.value && makeSel.value && modelSel.value)) return;
        var t = $('veh-conf-text');
        if (t) t.textContent = '\u2713 Fits your ' + yearSel.value + ' ' + makeSel.value + ' ' + modelSel.value + ' \u2014 2" receiver confirmed';
        var si = $('veh-selector-inner'); if (si) si.style.display = 'none';
        var cf = $('veh-confirmed'); if (cf) cf.style.display = 'block';
        root.querySelectorAll('.veh-chip').forEach(function (c) { c.classList.remove('selected'); });
      }
      function clearVehicle() {
        var si = $('veh-selector-inner'); if (si) si.style.display = 'block';
        var cf = $('veh-confirmed'); if (cf) cf.style.display = 'none';
        yearSel.value = ''; makeSel.value = ''; makeSel.disabled = true;
        modelSel.innerHTML = '<option value="">Model</option>'; modelSel.disabled = true;
        if (submitBtn) submitBtn.disabled = true;
        root.querySelectorAll('.veh-chip').forEach(function (c) { c.classList.remove('selected'); });
      }
      if (submitBtn) submitBtn.addEventListener('click', confirmVehicle);
      var clearBtn = $('veh-clear'); if (clearBtn) clearBtn.addEventListener('click', clearVehicle);

      root.querySelectorAll('.veh-chip').forEach(function (chip) {
        chip.addEventListener('click', function () {
          var make = chip.getAttribute('data-make'), model = chip.getAttribute('data-model');
          root.querySelectorAll('.veh-chip').forEach(function (c) { c.classList.remove('selected'); });
          chip.classList.add('selected');
          yearSel.value = '2024'; onYear();
          makeSel.value = make; onMake();
          setTimeout(function () { modelSel.value = model; checkSubmit(); }, 50);
        });
      });
    }

    // Stats count-up
    (function () {
      var stats = [['stat-n1',180,1400],['stat-n2',15,1100],['stat-n3',355,1600],['stat-n4',20,1200]]
        .map(function (s) { return { el: $(s[0]), target: s[1], duration: s[2] }; })
        .filter(function (s) { return s.el; });
      if (!stats.length) return;
      var triggered = false;
      function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
      function runCountUp() {
        var start = performance.now();
        stats.forEach(function (s) {
          s.el.textContent = '0';
          (function tick(now) {
            var p = Math.min((now - start) / s.duration, 1);
            s.el.textContent = Math.round(easeOut(p) * s.target);
            if (p < 1) requestAnimationFrame(tick);
          })(start);
        });
      }
      var section = root.querySelector('[data-comment-anchor="bc53c61fb0-div"]');
      if (section && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting && !triggered) { triggered = true; runCountUp(); io.disconnect(); }
        }, { threshold: 0.3 });
        io.observe(section);
      } else { runCountUp(); }
    })();

    // Wild gallery — load more
    var wildCurrent = 1;
    var wildBtn = $('wild-load-btn');
    if (wildBtn) {
      wildBtn.addEventListener('click', function () {
        wildCurrent++;
        var page = $('wild-p' + wildCurrent);
        if (page) { page.style.display = 'grid'; page.classList.add('wild-page-reveal'); }
        var counter = $('wild-counter'); if (counter) counter.textContent = 'Showing ' + (wildCurrent * 8) + ' of 24';
        if (wildCurrent >= 3) { var wrap = $('wild-load-wrap'); if (wrap) wrap.style.display = 'none'; }
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
